import { FC } from 'react';
import { useTranslation } from '@frontend/i18n';
import { ChecklistChipMenuField } from '@frontend/phone-ui';
import { ChecklistMenuField, useFormField } from '@frontend/design-system';

export type LocationStringRecord = Record<string, string>;

export type filterSelectorError = {
  name: string;
  value: boolean;
};

interface Props {
  disabled?: boolean;
  allLocationsOption: LocationStringRecord;
  selectedLocationsValue?: string[];
  onChange: (args: string[]) => void;
  trackingId?: string;
  label?: string;
}

export const LocationsSelector: FC<React.PropsWithChildren<Props>> = ({
  allLocationsOption,
  selectedLocationsValue,
  onChange,
  trackingId = 'location-selector',
  label,
}) => {
  const { t } = useTranslation('calls', { keyPrefix: 'calls-filter' });
  const locationsFieldProps = useFormField(
    {
      type: 'checklist',
      value: selectedLocationsValue,
    },
    [selectedLocationsValue]
  );

  const allLocationsSorted = Object.entries(allLocationsOption).sort(([, nameA], [, nameB]) =>
    nameA.localeCompare(nameB)
  );

  return (
    <div>
      <ChecklistChipMenuField
        fieldProps={locationsFieldProps}
        label={label ?? t('Select Locations')}
        name='locations'
        onChange={onChange}
        trackingId={trackingId}
      >
        {allLocationsSorted?.map(([id, locationName]) => (
          <ChecklistMenuField.Option key={id} value={id}>
            {locationName}
          </ChecklistMenuField.Option>
        ))}
      </ChecklistChipMenuField>
    </div>
  );
};
